import React, {useRef, useEffect} from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DeletedSuccessfullyImg from '../../../../assets/images/deletedSuccessfully.png';
import useLangTranslation from '../../../customHooks/languageProvider';

const DeletedSuccessfully = ({ showDeletedModal, closeDeletedModal, msg = ''}) => {
    const { getLangTranslation } = useLangTranslation();
    const modalRef = useRef();
  
    useEffect(() => {
      if (showDeletedModal) {
          const modal = new Modal(modalRef.current, {
              backdrop: 'static',
              keyboard: false,
            });
          modal.show();
      }
    }, [showDeletedModal]);
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
                <div className="modal-body">
                    <img src={DeletedSuccessfullyImg} className="mx-auto d-block" alt="..." />
                    <h5 className='text-center my-6'>{msg || getLangTranslation('PARENT_USER_DELETED')}</h5>
                    <button className="btn btn-primary w-100" type="button" data-bs-dismiss="modal" aria-label="Close" onClick={closeDeletedModal}>
                        <span className="btn-upper-case">{getLangTranslation('DELETE_CHILD_GOT_IT', 'Got it')}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default DeletedSuccessfully